class QuickBuyModal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)

    this.els?.close?.elements?.forEach(close => {
      this.listeners.add(close, `click`, this.handleClose)
    })
  }

  show () {
    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('quick-buy-modal')) {
  customElements.define('quick-buy-modal', QuickBuyModal)
}

class QuickBuyModalForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (this.formEl.dataset.zakekeProduct === 'true') {
      this.handleZakekeProduct = this.handleZakekeProduct.bind(this)
      this.listeners.add(this.submitBtnEl, 'click', this.handleZakekeProduct)
    } else {
      // Product form handles the add to cart - we dont need to fire it twice
      // Just close the modal.
      this.closeModal = this.closeModal.bind(this)
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
        this.closeModal,
      )
    }
  }

  closeModal (et) {
    this.modalEl?.handleClose()

    const cartEvent = new CustomEvent('quickBuy:added')

    document.dispatchEvent(cartEvent)
  }

  handleZakekeProduct (evt) {
    evt.preventDefault()
    evt.stopPropagation()

    const pid = this.formEl.querySelector('input[name="zakeke-product-id"]')
      .value

    const originalAction = this.formEl.action
    this.formEl.action = `${window.zakekeUrl || '/apps/zakeke'}?pid=${pid}`

    window.onpageshow = function (event) {
      if (event.persisted) {
        this.formEl.action = originalAction
      }
    }

    this.formEl.submit()
  }

  get modalEl () {
    return this.externalEls?.modal?.element
  }

  get formEl () {
    return this.els?.form?.element
  }

  get submitBtnEl () {
    return this.els?.button?.element
  }

  get optionChoicesEl () {
    return this.containerEl?.querySelector(
      '[data-product-variant-dropdown-external-el="option-choice"]',
    )
  }

  get containerEl () {
    return this.closest(
      '[data-product-variant-dropdown-external-el="container"]',
    )
  }
}

if (!customElements.get('quick-buy-modal-form')) {
  customElements.define('quick-buy-modal-form', QuickBuyModalForm)
}
